module.exports = __webpack_public_path__ + "static/media/Medalha-Desabilitada.97b09b87.svg";